import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFormatParagraphSpacing = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M5 1.75v16.5m0-16.5-3.25 3m3.25-3 3.25 3M5 18.25l-3.25-3m3.25 3 3.25-3m3.5-10.5h6.5M11.75 10h6.5m-6.5 5.25h6.5"
	})]
});
const ForwardRef = forwardRef(SvgFormatParagraphSpacing);
export { ForwardRef as ReactComponent };
